import AabHero from './AabHero';

customElements.define('aab-hero', AabHero);
